export const brandColorHex = "#118689";
